module.exports = __webpack_public_path__ + "img/Inventory-Management-Tab.918f51a7.svg";